import React, { useId } from 'react';

import scss from './ShapePreview.module.scss';

const FADE_GRADIENTS = {
  fadeBottom: { y1: 1, y2: 0, opacity: 0.85 },
  fadeTop: { y1: 0, y2: 1, opacity: 0.8 },
};

const PREVIEWS = {
  rect: () => <rect x='10' y='7' width='28' height='18' fill='currentColor' />,
  rounded: () => <rect x='10' y='7' width='28' height='18' rx='5' fill='currentColor' />,
  circle: () => <circle cx='24' cy='16' r='10' fill='currentColor' />,
  line: () => <rect x='8' y='15' width='32' height='2.5' rx='1.25' fill='currentColor' />,
  arrow: () => <path d='M8 14.75h22V10l10 6-10 6v-4.75H8z' fill='currentColor' />,
  overlay: () => <rect x='0' y='0' width='48' height='32' fill='#000' fillOpacity='0.3' />,
  fadeBottom: (gradientId) => <rect x='0' y='12' width='48' height='20' fill={`url(#${gradientId})`} />,
  fadeTop: (gradientId) => <rect x='0' y='0' width='48' height='18' fill={`url(#${gradientId})`} />,
};

function ShapePreview({ id }) {
  const gradientId = `ms-fade-${useId().replace(/:/g, '')}`;
  const gradient = FADE_GRADIENTS[id];

  return (
    <svg viewBox='0 0 48 32' className={scss.preview} aria-hidden='true'>
      {gradient ? (
        <defs>
          <linearGradient id={gradientId} x1='0' y1={gradient.y1} x2='0' y2={gradient.y2}>
            <stop offset='0' stopColor='#000' stopOpacity={gradient.opacity} />
            <stop offset='1' stopColor='#000' stopOpacity='0' />
          </linearGradient>
        </defs>
      ) : null}
      {PREVIEWS[id]?.(gradientId)}
    </svg>
  );
}

export default ShapePreview;
